import { CenterGridWrapper } from '../styles';
import { ISwapQualityIssueForList } from '@nkr/models/index';
import { SwapQualityIssueListType, SwapQualityIssueReportedBy } from '@nkr/enums/index';
import CommonList from './common-list';

interface IProps {
    centerId: number,
    data: ISwapQualityIssueForList[],
    listType: SwapQualityIssueListType,
    reportedBy: SwapQualityIssueReportedBy,
    isAdminLogin: boolean,
    onConfirmReopen: (id: number) => void
}

const CenterMicrositeList = (props: IProps) => {
    return (
        <CenterGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                data={props.data}
                centerId={props.centerId}
                listType={props.listType}
                reportedBy={props.reportedBy}
                isAdmin={false}
                isAdminLogin={props.isAdminLogin}
                onConfirmReopen={props.onConfirmReopen}
            />
        </CenterGridWrapper>
    );
}

export default CenterMicrositeList;